export const BREAKPOINTS = {
  small: 576,
  medium: 900,
  large: 900,
  xlarge: 1200,
}

export const DEVICE = {
  mobile: `(max-width: ${BREAKPOINTS.small}px)`,
  tablet: `(max-width: ${BREAKPOINTS.medium}px)`,
  laptop: `(min-width: ${BREAKPOINTS.large}px)`,
  desktop: `(min-width: ${BREAKPOINTS.xlarge}px)`,
}
